import { queryOptions, useQuery } from '@tanstack/react-query';
import { getNotificationsMeta, mapNotificationsMeta } from '@/services/api/notifications';

export const NOTIFICATIONS_QUERY_KEY = ['notifications'] as const;
export const NOTIFICATIONS_META_QUERY_KEY = [...NOTIFICATIONS_QUERY_KEY, 'meta'] as const;

const META_STALE_TIME_MS = 30 * 60 * 1000;

// Capabilities and approver options change only on a bop-api config deploy - cache long
export const notificationsMetaQueryOptions = () =>
  queryOptions({
    queryKey: NOTIFICATIONS_META_QUERY_KEY,
    queryFn: () => getNotificationsMeta(),
    select: mapNotificationsMeta,
    staleTime: META_STALE_TIME_MS,
  });

export const useNotificationsMeta = () => useQuery(notificationsMetaQueryOptions());
